import React from "react";

import "./Contact.css";
function Contact() {
  return (
    <div className="contact_main cursor ">
      <div className="color-white f-1-2 f-500"> HGS</div>
      <div className=" mt-4">
        <div className="d-flex  gap-3 mt-3 overflow-wrap-anywhere">
          <div>
            <img
              src={`https://www.pathways.in/asset/img/location_white.svg`}
              className="contact-icon"
            />
          </div>
          <div className="color-white f-1">
            HGS Palla Distt. Nuh (Haryana) Pin Code – 122107
          </div>
        </div>
        <div className="d-flex   gap-3 mt-3 overflow-wrap-anywhere">
          <div>
            <img
              src={`https://www.pathways.in/asset/img/email_us_white.svg`}
              className="contact-icon"
            />
          </div>
          <div className="color-white f-1">
            principal.pallahgs@soscvindia.org
          </div>
        </div>
        <div className="d-flex  gap-3 mt-3 overflow-wrap-anywhere">
          <div>
            <img
              src={`	https://www.pathways.in/asset/img/phone_icon_white.svg`}
              className="contact-icon"
            />
          </div>
          <div className="color-white f-1">8979870545</div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
